import $http from '@/api/index';
import store from '@/store';

export default {
  async fetch(id) {
    return $http.get(`/api/board/${id}`);
  },
  async search(filters, source = {}) {
    if (!filters.siteId) {
      filters.siteId = store.getters.siteId;
    }
    return $http.post('/api/board/search', filters, { cancelToken: source.token })
      .catch((e) => {
        console.warn('Search exception:', e);
        return { canceled: true, results: [] };
      });
  },
};
